import Loader from '../custom/loader/main'
import { lazy, Suspense } from 'react'


const Main = lazy(() => import('../components/report/approvedResults/main')) 
const ApprovedResults = () => {
    return(

        <Suspense fallback={<Loader/>}>
            <Main/>
        </Suspense>
    )
}

export default ApprovedResults